import SpotPage from './SpotPage';

export default SpotPage;
